import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface AdBannerProps {
  placement: "top" | "bottom" | "sidebar";
}

const AdBanner = ({ placement }: AdBannerProps) => {
  const { data: banners = [] } = useQuery({
    queryKey: ["ad-banners", placement],
    queryFn: async () => {
      const now = new Date().toISOString();
      const { data, error } = await supabase
        .from("ad_banners")
        .select("*")
        .eq("placement", placement)
        .eq("active", true)
        .order("position", { ascending: true });
      if (error) throw error;
      // Filter by date range client-side
      return (data ?? []).filter((b: any) => {
        if (b.starts_at && new Date(b.starts_at) > new Date()) return false;
        if (b.expires_at && new Date(b.expires_at) < new Date()) return false;
        return true;
      });
    },
  });

  if (banners.length === 0) return null;

  const banner = banners[0]; // Show first matching banner

  return (
    <div className="my-8">
      <a
        href={banner.link_url}
        target="_blank"
        rel="noopener noreferrer sponsored"
        className="block rounded-xl overflow-hidden border border-border/50 hover:shadow-md transition-shadow group"
      >
        <div className="relative">
          <img
            src={banner.image_url}
            alt={banner.title}
            className="w-full h-auto object-cover group-hover:scale-[1.01] transition-transform duration-300"
            loading="lazy"
          />
          <span className="absolute bottom-2 right-2 bg-foreground/60 text-primary-foreground text-[10px] font-body px-2 py-0.5 rounded">
            Ad
          </span>
        </div>
      </a>
    </div>
  );
};

export default AdBanner;
